import winston from 'winston'
import NewrelicWinston from 'newrelic-winston'
import colors from 'colors'
import {
  APP_NAME,
  DEV,
  NEW_RELIC_APP_NAME,
  NEW_RELIC_LICENSE_KEY
} from 'env'

const logColors = {
  error: 'red',
  warn: 'yellow',
  info: 'blue',
  verbose: 'cyan',
  debug: 'magenta',
  silly: 'green'
}

const colorise = (message, level = 'info') => (colors[logColors[level]] || (x => x))(message)

const simple = (info) => {
  if (info.message.constructor === Object) {
    info.message = JSON.stringify(info.message, null, 4)
  }

  const label = colorise(`${info.timestamp} [${APP_NAME}] ${info.level}`, info.level)
  const message = info.message

  return `${label}: ${message}`
}

const logger = winston.createLogger({
  level: 'info',
  format: winston.format.combine(
    winston.format.timestamp(),
    winston.format.printf(simple)
  ),
  transports: [
    DEV && new winston.transports.Console({
      level: 'verbose'
    }),
    NEW_RELIC_LICENSE_KEY && new NewrelicWinston({
      level: 'info',
      'app_name': NEW_RELIC_APP_NAME,
      'license_key': NEW_RELIC_LICENSE_KEY
    })
  ].filter(x => x)
})

export default logger
